import { render, staticRenderFns } from "./Avanzamento.vue?vue&type=template&id=129be7e8&scoped=true&"
import script from "./Avanzamento.vue?vue&type=script&lang=js&"
export * from "./Avanzamento.vue?vue&type=script&lang=js&"
import style0 from "./Avanzamento.vue?vue&type=style&index=0&id=129be7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129be7e8",
  null
  
)

export default component.exports